import { SET_UDAS_SOCKET } from "redux/constants/portal";

const initialState = {
  udasSocket: null,
};

const udasSocket = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_UDAS_SOCKET:
      return {
        ...state,
        udasSocket: payload,
      };
  }
  return state;
};

export default udasSocket;
